import { getPageSections } from '../../api';

import type { Scope } from '#packages/sections';
import type { CompRef } from 'types/documentServices';

export const enforceSectionAnchorInfo = async (
  scope: Scope,
  pageRef: CompRef,
) => {
  const { editorAPI } = scope;
  const pageSections = getPageSections(scope, pageRef);

  const sectionsWithoutAnchor = pageSections.filter(
    (sectionRef: CompRef) => !editorAPI.components.anchor.get(sectionRef),
  );

  if (sectionsWithoutAnchor.length === 0) {
    return;
  }

  sectionsWithoutAnchor.forEach((sectionRef) => {
    const displayName = editorAPI.components.getDisplayName(sectionRef);
    editorAPI.components.anchor.update(sectionRef, { name: displayName });
  });

  await editorAPI.waitForChangesAppliedAsync();
};
